import React from 'react';
import { Users, Shield, Globe, Heart } from 'lucide-react';

const features = [
  {
    icon: Users,
    title: "A Safe Haven for Connection and Belonging",
    description: "Your diagnosis is just one part of your story—not your entire identity. CloseCircle is a welcoming community where you can meet people who truly understand and accept you. Leave behind the stigma and explore opportunities for love, friendship, and support in a judgment-free environment."
  },
  {
    icon: Shield,
    title: "Privacy is Our Priority",
    description: "Your comfort and privacy are at the heart of what we do. On CloseCircle, you control what you share and when you share it. Every member's information remains secure and anonymous until they decide otherwise. We're proud to welcome everyone—regardless of race, religion, or sexual orientation, including LGBTQ+ singles."
  },
  {
    icon: Globe,
    title: "A Global Network, Built for You",
    description: "You're not alone. Millions of people worldwide are living with STIs/STDs. CloseCircle connects you to a vibrant, like-minded community—whether it's local members in your city or millions of others around the globe."
  }
];

export function About() {
  return (
    <section className="py-20 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16 animate-fade-in">
          <div className="inline-flex items-center gap-2 text-primary-500 mb-4">
            <Heart className="w-6 h-6" />
            <h2 className="text-2xl font-bold">A New Community for Dating & Support</h2>
          </div>
          <p className="text-xl text-gray-600 dark:text-gray-300 max-w-3xl mx-auto">
            CloseCircle is the trusted platform for singles navigating life with Herpes, HPV, HIV/AIDS, 
            Hepatitis B, Hepatitis C, Chlamydia, or other STIs/STDs. Built as a fully anonymous, 
            inclusive space, CloseCircle is where connection and understanding come together.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-12">
          {features.map((feature, index) => (
            <div 
              key={index}
              className="animate-fade-in-up"
              style={{ animationDelay: `${index * 200}ms` }}
            >
              <div className="flex items-center gap-3 mb-4">
                <feature.icon className="w-8 h-8 text-primary-500" />
                <h3 className="text-xl font-semibold text-gray-900 dark:text-white">
                  {feature.title}
                </h3>
              </div>
              <p className="text-gray-600 dark:text-gray-300 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}